import React from "react";
import ReactDOM from "react-dom";
import { renderToStaticMarkup } from 'react-dom/server';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import history from "./actions/history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import indexRoutes from "./routes/index.jsx";
import {initialize, addTranslationForLanguage } from "react-localize-redux"
import thunk from 'redux-thunk'
import Amplify from 'aws-amplify';
import reducers from './reducers/index.js';
import aws_exports from './aws-exports';
import { retrieveUserSession } from "./actions/auth"

import "assets/scss/material-dashboard-pro-react.css?v=1.1.0";

Amplify.configure(aws_exports);

const store = createStore(reducers, applyMiddleware(thunk));
console.log(window.msdContent);
store.dispatch(initialize({
      languages: [
        { name: 'English', code: 'en' }
      ],
      options: { renderToStaticMarkup }      
  })
);
store.dispatch(addTranslationForLanguage(window.msdContent, "en"));
store.dispatch(retrieveUserSession());

const SecretRoute = ({ component: Component, ...rest }) => {
  return (
  <Route {...rest} render={(props) => {
    return (
    store.getState().auth.loggedIn === true
      ? <Component {...props} />
      : <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
        }} />
  )}} />
)};

function handleChange() {
  unsubscribe();
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          {indexRoutes.map((prop, key) => {
              if(!prop.isLoggedIn ){
                return <Route path={prop.path} component={prop.component} key={key} />;
              }else{
                return <SecretRoute path={prop.path} component={prop.component} key={key} />;
              }
          })}
        </Switch>
      </Router>
    </Provider>
    ,
    document.getElementById("root")
  );
}
const unsubscribe = store.subscribe(handleChange);




// WEBPACK FOOTER //
// ./src/index.js